import { flashError } from "../../utils/flashMessage";
import { getHttpClient, errorDesconocido, safeHandle401, handle401 } from "../../utils/httpClient";
import { notification } from "antd";

export const GET_REQUEST = "GET_REQUEST";
export const PUT_REQUEST = "PUT_REQUEST";
export const POST_REQUEST = "POST_REQUEST";
export const DELETE_REQUEST = "DELETE_REQUEST";

const listPattern = (section, getRootState) => {
    /**
     * Basic List Actions
     */
    const listError = (error) => {
        return { type: `${section}_ERROR`, error };
    };

    const listLoading = () => {
        return { type: `${section}_LOADING` };
    };

    const listSuccess = (data) => {
        return { type: `${section}_SUCCESS`, data };
    };

    const listReset = () => {
        return { type: `${section}_RESET` };
    };

    /**
     * Basic List Element Actions
     */
    const listElementUpdate = (data) => {
        return { type: `${section}_ELEMENT_UPDATE`, data };
    };

    const listElementUpdateV2 = (data) => {
        return { type: `${section}_ELEMENT_UPDATE_V2`, data };
    };

    const listElementRemove = (id) => {
        return { type: `${section}_ELEMENT_REMOVE`, id };
    };

    /**
     * Action Creators / Secondary Request
     */
    const secondaryError = (error) => {
        return { type: `${section}_SECONDARY_REQUEST_ERROR`, error };
    };

    const secondaryLoading = () => {
        return { type: `${section}_SECONDARY_REQUEST_LOADING` };
    };

    const secondarySuccess = (data) => {
        return { type: `${section}_SECONDARY_REQUEST_SUCCESS`, data };
    };

    const secondaryReset = () => {
        return { type: `${section}_SECONDARY_REQUEST_RESET` };
    };

    /**
     * Basic Request Pattern
     */
    const requestPattern = (
        url,
        method,
        form,
        customError,
        customLoading,
        customSuccess,
        onSuccess = null,
        cache = false
    ) => {
        return async (dispatch, getState) => {
            dispatch(customLoading(true));

            const headers = { "Content-Type": "application/json" };

            try {
                const cliente = await getHttpClient(dispatch, getState());

                let response;

                if (method === POST_REQUEST) {
                    response = await cliente.post(url, form, { headers: headers });
                } else if (method === PUT_REQUEST) {
                    response = await cliente.put(url, form, { headers: headers });
                } else if (method === GET_REQUEST) {
                    response = await cliente.get(url, { params: form }, { headers: headers });
                } else if (method === DELETE_REQUEST) {
                    response = await cliente.delete(url, {}, { headers: headers });
                } else {
                    alert("Unknown METHOD in requestPattern");
                }

                dispatch(customSuccess(response.data));

                if (typeof onSuccess === "object" && onSuccess !== null) {
                    notification.success(onSuccess);
                } else if (onSuccess !== null) {
                    onSuccess(dispatch);
                }

                return response.data;
            } catch (e) {
                const test401 = safeHandle401(dispatch, getState);
                test401(e);

                if (e.response) {
                    // The request was made and the server responded with a status code
                    // that falls out of the range of 2xx
                    if (e.response.status == 404) {
                        dispatch(customError(e.response.statusText));
                    } else if (e.response.status == 409) {
                        // HTTP_CONFLICT
                        // Hoy solo se usa para fallar en los DELETEs
                        dispatch(customError("Not allowed"));
                        flashError({ description: "It is not possible to delete the entity." });
                        return e.response.data;
                    } else if (e.response.status != 400) {
                        dispatch(customError("Unknown error"));
                        flashError({ description: "Unknown error." });
                    }

                    return e.response.data;
                }

                dispatch(customError("Unknown error"));
                errorDesconocido();
                return "Error";
            }
        };
    };

    const getListPattern = (url, form, onSucces = null) => {
        return requestPattern(url, GET_REQUEST, form, listError, listLoading, listSuccess, onSucces, false);
    };

    const actionPutV2Pattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            PUT_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            listElementUpdateV2,
            onSucces,
            false
        );
    };

    const actionPutPattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            PUT_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            listElementUpdate,
            onSucces,
            false
        );
    };

    const actionDeletePattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            DELETE_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            listElementRemove,
            onSucces,
            false
        );
    };

    const actionPostPattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            POST_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            listElementUpdate,
            onSucces,
            false
        );
    };

    const secondaryPostPattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            POST_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            secondarySuccess,
            onSucces,
            false
        );
    };

    const secondaryPutPattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            PUT_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            secondarySuccess,
            onSucces,
            false
        );
    };

    const secondaryGetPattern = (url, form, onSucces = null) => {
        return requestPattern(
            url,
            GET_REQUEST,
            form,
            secondaryError,
            secondaryLoading,
            secondarySuccess,
            onSucces,
            false
        );
    };

    /**
     * Selectors
     */
    const isLoaded = (state) => getRootState(state).loaded;
    const isLoading = (state) => getRootState(state).loading;
    const getError = (state) => getRootState(state).error;
    const getData = (state) => getRootState(state).data;
    const getMeta = (state) => getRootState(state).meta;
    const getList = (state) => getRootState(state).sortedData;
    const getExtra = (state) => getRootState(state).extra;

    const isSecondaryLoading = (state) => getRootState(state).subrequest.loading;
    const getSecondaryError = (state) => getRootState(state).subrequest.error;
    const getSecondaryData = (state) => getRootState(state).subrequest.data;
    const getSecondarySuccess = (state) => getRootState(state).subrequest.success;

    const generalDownload = (url, name) => {
        return (dispatch, getState) => {
            const cliente = getHttpClient(dispatch, getState());
            cliente.then((axios) => {
                axios
                    .get(url, {
                        responseType: "arraybuffer",
                    })
                    .then((response) => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement("a");
                        link.href = url;
                        link.setAttribute("download", `${name}`);
                        document.body.appendChild(link);
                        link.click();
                    })
                    .catch(handle401(dispatch, getState))
                    .catch((e) => {
                        if (e.response) {
                            // The request was made and the server responded with a status code
                            // that falls out of the range of 2xx
                            if (e.response.status == 404) {
                                alert("Se ha producido un error inesperado ");
                                return;
                            }
                        }

                        errorDesconocido();
                    });
            });
        };
    };

    return {
        getListPattern,

        actionPutV2Pattern,

        actionPutPattern,
        actionDeletePattern,
        actionPostPattern,

        secondaryGetPattern,
        secondaryPostPattern,
        secondaryPutPattern,

        isLoaded,
        isLoading,
        getError,
        getData,
        getMeta,
        getList,
        getExtra,

        isSecondaryLoading,
        getSecondaryError,
        getSecondaryData,
        getSecondarySuccess,

        listReset,
        listLoading,
        listElementUpdate,
        listElementRemove,
        listError,

        generalDownload,
    };
};

export default listPattern;
